import pluralize from 'pluralize';
import { memo } from 'react';

import { BOARDLESS_LOCATION_NAME } from '~/components/v2/components/shared/selectionBar/consts';
import { type FlatListItem } from '~/components/v2/components/shared/selectionBar/types';

export type AgentSelectedItemGroupHeaderProps = {
  listItem?: FlatListItem;
};

const getBoardLocationLabel = (boardName: string, itemCount: number): string => {
  if (boardName === BOARDLESS_LOCATION_NAME) {
    return itemCount === 1 ? 'from another location' : 'from other locations';
  }

  return `from ${boardName} board`;
};

export const AgentSelectedItemGroupHeader = memo(({ listItem }: AgentSelectedItemGroupHeaderProps) => {
  if (!listItem || listItem.type !== 'header') {
    return null;
  }

  return (
    <p className="truncate px-1.5 font-bold text-10 text-white/40 uppercase tracking-wide">
      {listItem.itemCount} {pluralize('item', listItem.itemCount)}{' '}
      {getBoardLocationLabel(listItem.boardName, listItem.itemCount)}
    </p>
  );
});

AgentSelectedItemGroupHeader.displayName = 'AgentSelectedItemGroupHeader';
